import * as d3Axis from 'd3-axis';
import { select as d3Select } from 'd3-selection';
import { includes } from 'lodash';
import React, { useEffect, useRef } from 'react';

const axisKeys = ['scale', 'ticks', 'tickArguments', 'tickValues', 'tickFormat', 'tickSize', 'tickSizeInner', 'tickSizeOuter', 'tickPadding'];

export default (props) => {
    const axisElementRef = useRef();

    const renderAxis = () => {
        if (!axisElementRef.current) {
            return;
        }

        const axisElement = axisElementRef.current;
        const axisType = `axis${props.orient}`;
        const axis = d3Axis[axisType]();

        for (const key in props) {
            if (!includes(axisKeys, key)) {
                continue;
            }
            axis[key](props[key]);
        }
        d3Select(axisElement).call(axis);
        d3Select(axisElement).style('font-size', `${(props.fontSize / 100) * 0.9 || '1'}em`);

        if (props.maxLabelWidth) {
            let maxWidth = 0;

            d3Select(axisElement)
                .selectAll('text')
                .each(function () {
                    maxWidth = Math.max(this.getBBox().width + axis.tickSize() + axis.tickPadding(), maxWidth);
                });

            props.maxLabelWidth(Math.max(maxWidth, 10));
        }

        if (props.maxLabelHeight) {
            let maxHeight = 0;

            d3Select(axisElement)
                .selectAll('text')
                .each(function () {
                    maxHeight = Math.max(this.getBBox().height + axis.tickSize() + axis.tickPadding(), maxHeight);
                });

            props.maxLabelHeight(Math.max(maxHeight, 10));
        }
    };

    useEffect(() => {
        renderAxis();
    }, [props.orient, props.height, props.orient, props.fontSize, props.width, props.ticks, props.scale]);

    return <g className={`Axis Axis-${props.orient} ${props.className ? props.className : ''}`} ref={axisElementRef} transform={props.translate} />;
};
